// first number is megabytes
export const FS_LIMIT = 10 * 1024 * 1024;
